<div class="wrapper bg-area">
  <section id="confirmacao">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6" style="margin: 0px auto;">
          <div class="bar__container">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li class="active active-step"><i class="fas fa-check"></i>Dados Pessoais</li>
              <li class="active active-step"><i class="fas fa-check"></i>Pagamento</li>
              <li class="active active-step"><i class="fas fa-check"></i>Segurança</li>
              <li class="active active-step"><i class="fas fa-check"></i>Confirmação</li>
            </ul>
          </div>
        </div>
      </div>
      <form>
        <div class="body-faca-parte columns">
          <div class="column is-6" style="margin: 0px auto;">

            <div class="dados-pessoais">

              <div class="text-center">
                <img class="icon-montreal" src="assets/img/icon-sucesso-cadastro.png" />
                <h2>OBRIGADO!</h2>
              </div>

              <p>
                <strong>Sua proposta já está sendo analizada!</strong>
                <br/>
                <br/>
                <strong>Enquanto suas informações estão Sendo Processadas, você pode dar uma olhada nos Nossos Hotéis ou Acessar o Portal do Cliente. </strong>
              </p>
              <br/>
              <p>
                Assim que tivermos um retorno, eu te envio um email, ok?
              </p>

              <p>Caso tenha alguma dúvida ou não receba minha mensagem em até 48hs, verifique sua Caixa de Spam ou Entre em Contato conosco pelo <a href="/contatos"><strong>Chat</strong></a> ou pela Central de Atendimento, no <strong>0800 610 3311</strong>.</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</div>
